import { render } from "./newsletter-sign-up.vue?vue&type=template&id=1605bcf7"
import script from "./newsletter-sign-up.vue?vue&type=script&lang=js"
export * from "./newsletter-sign-up.vue?vue&type=script&lang=js"

import "./newsletter-sign-up.vue?vue&type=style&index=0&id=1605bcf7&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__